import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { OutageComponent } from './outage/outage.component';
// Remove this import if you're getting rid of session logic
// import { LocalsessionService } from './localsession.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    OutageComponent
  ]
})
export class AppComponent implements OnInit {
  title = 'info-mgmt-tool';

  // Remove this if you're no longer tracking session user
  // username: string | null = null;

  // Remove this if you're not showing/hiding things based on login route
  // isLoginPage: boolean = false;

  // constructor(
  //   private router: Router,
  //   private localsessionService: LocalsessionService // remove this too
  // ) {

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Add any route-specific logic here

        // Remove this logic if you're not using login page check
        // this.isLoginPage = event.url === '/login';

        // Remove session check
        // this.username = this.localsessionService.getSession();
      }
    });
  }

  ngOnInit(): void {
    // Add any initialization logic here

    // Remove session check
    // this.username = this.localsessionService.getSession();
  }
}
